module.exports = __webpack_public_path__ + "img/underConstrunction.ed5b3dbf.png";